import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import style from './index.module.scss';

const DeadUserInfo = ({ user }) => (
  <div>
    <div>
      <Dotdotdot clamp={2} useNativeClamp>
        {user.headline}
      </Dotdotdot>
    </div>
    {user.last_location && (
      <div className={style.address}>
        <i className="icon-map-marker push-eighth--right" />
        {[user.last_location.city, user.last_location.country]
          .filter(Boolean)
          .join(', ') || user.last_location.address}
      </div>
    )}
  </div>
);

DeadUserInfo.propTypes = {
  user: PropTypes.object.isRequired,
};

export default DeadUserInfo;
